<mat-card>
  <mat-card-header>
    <h1>
      Selections</h1>
  </mat-card-header>
  <mat-card-content>
    <ng-form novalidation>
      <div class="form-container">
        <section class="custom-check-box-group">
          <mat-checkbox class="custom-check-box" name="showInfo" [(ngModel)]="showInfo">Document Information
          </mat-checkbox>
          <mat-checkbox class="custom-check-box" name="showdates" [(ngModel)]="showdates">Document Dates & Deadlines
          </mat-checkbox>
          <mat-checkbox class="custom-check-box" name="showbusinessOwner" [(ngModel)]="showbusinessOwner">Additional
            Information
          </mat-checkbox>
          <mat-checkbox class="custom-check-box" name="showupi" [(ngModel)]="showupi">Product Data</mat-checkbox>
          <mat-checkbox class="custom-check-box" name="showcomemnts" [(ngModel)]="showcomemnts">Comments</mat-checkbox>
          <mat-checkbox class="custom-check-box" name="showlinked" [(ngModel)]="showlinked">Linked Documents
          </mat-checkbox>
          <mat-checkbox class="custom-check-box" name="shownotifications" [(ngModel)]="shownotifications">Event
            Notifications
          </mat-checkbox>
          <ul class="NotificatinList" *ngIf="shownotifications">
            <li>
              <mat-checkbox class="custom-check-box" name="future" [(ngModel)]="future">
                Include
                Future Dated Event Notifications Only
              </mat-checkbox>
            </li>
            <li>
              <mat-checkbox class="custom-check-box" name="past" [(ngModel)]="past">Include
                Past Dated Event Notifications Only
              </mat-checkbox>
            </li>
            <li>
              <mat-checkbox class="custom-check-box" name="trackTask" [(ngModel)]="trackTask"
                (change)="trackChanged($event)">
                Include only Task Tracked Notifications
              </mat-checkbox>
            </li>
          </ul>
        </section>
      </div>
    </ng-form>
    <a class="actionButtons" mat-raised-button color="primary" (click)="print()">Download PDF</a>
    <a class="actionButtons" mat-raised-button color="accent"
      [routerLink]="['/',(documentID$ | async).objectStore,'DocumentView',(documentID$ | async).id]">Close</a>
  </mat-card-content>
</mat-card>

<ng-container *ngIf="document$ | async as selectedDocument; else loading">
  <div [ngClass]="{'printPreview':!printing,'print':printing}">
    <div id="toPrint" #toPrint>
      <h1>SUMMARY</h1>
      <table width="100%">
        <tr>
          <td><b>{{selectedDocument?.propertiesObj?.DocumentTitle}} -
              {{selectedDocument?.propertiesObj?.ContractIdentifier}}
              <span *ngIf="!!selectedDocument?.propertiesObj?.ContractDeletedDate" class="deleted"> - Deleted</span></b>
          </td>
          <td align="right"><b>Contract Status:
              {{ selectedDocument.propertiesObj?.ContractStatus | asyncChoiceList:(documentID$ | async).objectStore:'ContractStatuses' | async}}
            </b></td>
        </tr>
      </table>

      <table width="100%">
        <tr>
          <td><b>Contract Name: </b></td>
          <td colspan=3;>{{selectedDocument?.propertiesObj?.DocumentTitle}}</td>
        </tr>
        <tr>
          <td><b>Location: </b></td>
          <td colspan=3>{{selectedDocument?.propertiesObj?.FoldersFiledIn}}</td>
        </tr>
        <tr>
          <td><br></td>
        </tr>
        <ng-container *ngIf="showInfo">
          <tr>
            <td colspan=4;><b>
                <h1>Document Information</h1>
              </b> </td>
          </tr>
          <tr>
            <td><b>Contract Identifer: </b></td>
            <td>{{selectedDocument?.propertiesObj?.ContractIdentifier}}</td>
            <td><b>Document Class: </b></td>
            <td>
              {{ selectedDocument.propertiesObj?.ClassDescription | asyncChoiceList:(documentID$ | async).objectStore:'ACLDocumentClasses' | async}}
            </td>
          </tr>
          <tr>
            <td><b>Contract Status: </b></td>
            <td>
              {{ selectedDocument.propertiesObj?.ContractStatus | asyncChoiceList:(documentID$ | async).objectStore:'ContractStatuses' | async}}
            </td>
            <td><b>Type of Agreement: </b></td>
            <td>
              {{ selectedDocument.propertiesObj?.ContractAgreementType | asyncChoiceList:(documentID$ | async).objectStore:'ContractAgreementTypes' | async}}
            </td>
          </tr>
          <tr>
            <td><b>Location of Wet Ink: </b></td>
            <td>
              {{selectedDocument?.propertiesObj?.ContractWetInk}}
            </td>
            <td><b>Document Type: </b></td>
            <td>
              {{ selectedDocument.propertiesObj?.ContractType | asyncChoiceList:(documentID$ | async).objectStore:'ContractTypes' | async}}
            </td>
          </tr>
          <tr>
            <td><b>Contract Parties: </b></td>
            <td>
              {{selectedDocument?.propertiesObj?.ContractParties}}
            </td>
            <td><b>CMS ID: </b></td>
            <td>
              {{selectedDocument?.propertiesObj?.ContractCMSID}}
            </td>
          </tr>
          <tr>
            <td><br></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="showdates">
          <tr>
            <td colspan=4;><b>
                <h1>Document Dates & Deadlines</h1>
              </b> </td>
          </tr>
          <tr>
            <td><b>Contract Start Date: </b></td>
            <td>{{selectedDocument?.propertiesObj?.ContractStartDate | aspenDate}}</td>
            <td><b>Review Deadline Date: </b></td>
            <td>
              {{selectedDocument?.propertiesObj?.ContractReviewDeadlineDate | aspenDate}}
            </td>
          </tr>
          <tr>
            <td><b>Contract End Date: </b></td>
            <td>
              {{selectedDocument?.propertiesObj?.ContractEndDate | aspenDate}}
            </td>
            <td><b>Signature Date: </b></td>
            <td>
              {{selectedDocument?.propertiesObj?.ContractDateOfLastSignature | aspenDate}}
            </td>
          </tr>
          <tr>
            <td><b>No Alert Required: </b></td>
            <td>{{selectedDocument?.propertiesObj?.ContractNoAlertRequired ? 'Yes' : 'No'}}</td>
          </tr>
          <tr>
            <td><br></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="showbusinessOwner">
          <tr>
            <td colspan=4;><b>
                <h1>Additional Information</h1>
              </b> </td>
          </tr>
          <ng-container
            *ngIf="selectedDocument.propertiesObj.ContractBusinessOwner | asyncBusinessOwnerEntity | async as BusinessOwner">
            <tr>
              <td><b>Business Owner: </b></td>
              <td>{{BusinessOwner?.fullname}}</td>
              <td><b>Email: </b></td>
              <td>{{BusinessOwner?.email}}</td>
            </tr>
            <tr>
              <td><b>Contact Number: </b></td>
              <td>{{BusinessOwner?.telephone}}</td>
              <td><b>Department: </b></td>
              <td>{{BusinessOwner?.department}}</td>
            </tr>
            <tr>
              <td><b>Designation: </b></td>
              <td>{{BusinessOwner?.designation}}</td>
            </tr>

            <tr>
              <td><b>Document Department: </b></td>
              <td>{{selectedDocument?.propertiesObj?.ContractDepartment}}</td>
            </tr>
            <tr>
              <td><br></td>
            </tr>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showupi">
          <tr>
            <td colspan=4;><b>
                <h1>Product Data</h1>
              </b> </td>
          </tr>
          <tr>
            <td><b>UPI: </b></td>
            <td>{{selectedDocument?.propertiesObj?.ContractUPI}}</td>
          </tr>
          <tr>
            <td><b>Product: </b></td>
            <td colspan=3;>
              <span *ngFor="let item of selectedDocument?.propertiesObj?.ContractProducts; let last = last">
                {{ item | asyncChoiceList:(documentID$ | async).objectStore:'allProducts': 'allProducts' | async}}{{last?'':'; '}}
              </span>
            </td>
          </tr>
          <tr>
            <td><b>Molecule: </b></td>
            <td colspan=3;>
              <span *ngFor="let item of selectedDocument?.propertiesObj?.ContractMolecules; let last = last">
                {{ item | asyncChoiceList:(documentID$ | async).objectStore:'allMolecules': 'allMolecules' | async}}{{last?'':'; '}}
              </span>
            </td>
          </tr>
          <tr>
            <td><b>Territory: </b></td>
            <td colspan=3;>
              <span *ngFor="let item of selectedDocument?.propertiesObj?.ContractTerritories; let last = last">
                {{ item | asyncChoiceList:(documentID$ | async).objectStore:'allTerritories': 'allTerritories' | async}}{{last?'':'; '}}
              </span>
            </td>
          </tr>
          <tr>
            <td><br></td>
          </tr>
        </ng-container>
      </table>

      <ng-container *ngIf="showcomemnts">
        <table width=100%>
          <tr>
            <td colspan=3;><b>
                <h1>Comments</h1>
              </b> </td>
          </tr>
          <tr>
            <td><b>Date </b></td>
            <td><b>User </b></td>
            <td><b>Comment </b></td>
          </tr>
          <tr *ngFor="let comment of selectedDocument.annotations">
            <td>{{comment.propertiesObj.AnnotationDate | aspenDate}}</td>
            <td>{{comment.propertiesObj.AnnotationUser}}</td>
            <td>{{comment.propertiesObj.AnnotationText}}</td>
          </tr>
          <tr>
            <td><br></td>
          </tr>
        </table>
      </ng-container>
      <ng-container *ngIf="showlinked">
        <table width=100%>
          <tr>
            <td colspan=3;><b>
                <h1>Linked Documents</h1>
              </b> </td>
          </tr>
          <tr>
            <td><b>Contract ID</b></td>
            <td><b>Linked Contract Name</b></td>
            <td><b>Linked Contract Location</b></td>
          </tr>
          <tr *ngFor="let link of linkedDocuments$ | async">
            <td>{{link.propertiesObj?.ContractIdentifier}}</td>
            <td>{{link.propertiesObj?.DocumentTitle}}</td>
            <td>{{link.propertiesObj?.FoldersFiledIn}}</td>
          </tr>
          <tr>
            <td><br></td>
          </tr>
        </table>
      </ng-container>
      <ng-container *ngIf="shownotifications">
        <table width=100%>
          <tr>
            <td colspan=7;><b>
                <h1>Event Notifications</h1>
              </b> </td>
          </tr>
          <tr>
            <td><b>Seq</b></td>
            <td><b>Alert Date </b></td>
            <td><b>To </b></td>
            <td><b>Reminder Text </b></td>
            <td><b>Date Sent</b></td>
            <td><b>Task Complete </b></td>
            <td><b>Task Tracked </b></td>
          </tr>
          <ng-container *ngFor="let alert of filterAlerts(selectedDocument?.alerts)">
            <!-- {{alert | json}} -->
            <tr *ngIf="!alert?.propertiesObj.AlertSystem && !alert?.propertiesObj.AlertCancelled">
              <td>{{alert.propertiesObj?.AlertNotificationNumber}}</td>
              <td>{{alert.propertiesObj?.AlertDueDate | aspenDate}}</td>
              <td><span *ngFor="let toAddress of alert.propertiesObj?.AlertEmailAdresses;let last = last">{{toAddress}}
                  {{last?'':'; '}}</span></td>
              <td>{{alert.propertiesObj?.AlertMessageText}}</td>
              <td>{{alert.propertiesObj?.AlertSendDate | aspenDate}}</td>
              <td *ngIf="alert.propertiesObj?.AlertTrackTask">{{alert?.propertiesObj?.AlertTrackComplete? 'Yes' : 'No'}}
              </td>
              <td *ngIf="!alert.propertiesObj?.AlertTrackTask">N/A</td>
              <td>{{alert.propertiesObj?.AlertTrackTask? 'Tracked' : 'Not Tracked'}}</td>
            </tr>
          </ng-container>

        </table>
        <!-- </div> -->
        <br><br><br><br>
        <!-- </div> -->
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <mat-spinner></mat-spinner>
</ng-template>
